import { useMutation } from "react-query";
import { CreateCheckOutAttendanceLog } from "services/workSchedule";

export default function useCreateCheckOutAttendanceLog() {
  return useMutation(
    (data:any) => CreateCheckOutAttendanceLog(data),
  );
}
